import axios from "axios";

export const HTTP = axios.create({
  baseURL: "https://luinnycorporanapp.net/luinnycorporan/api",
  headers: {
    Accept: "application/json"
  }
});

/* 🔥 THIS IS REQUIRED */
HTTP.interceptors.request.use(config => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});